<template>
	<p v-if="Object.keys(working_question).length > 0 && question.values.field_type=='text'">
		<label :for="'question_'+question.id+'_'+participant_id">{{ question.values.label }}</label>
		<span v-if="read_only==true || working_question.answers_read_only[participant_id]==true"><p>{{ working_question.answers_summary[participant_id] }}</p></span>
		<input v-else type="text" :name="'question_'+question.id+'_'+participant_id" :id="'question_'+question.id+'_'+participant_id" v-model="working_question.answers_summary[participant_id]">
	</p>
	<p v-else-if="Object.keys(working_question).length > 0 && question.values.field_type=='textarea'">
		<label :for="'question_'+question.id+'_'+participant_id">{{ question.values.label }}</label>
		<span v-if="read_only==true || working_question.answers_read_only[participant_id]==true"><p>{{ working_question.answers_summary[participant_id] }}</p></span>
		<textarea v-else :name="'question_'+question.id+'_'+participant_id" :id="'question_'+question.id+'_'+participant_id" v-model="working_question.answers_summary[participant_id]"></textarea>
	</p>
	<p v-else-if="Object.keys(working_question).length > 0 && question.values.field_type=='select'">
		<label :for="'question_'+question.id+'_'+participant_id">{{ question.values.label }}</label>
		<span v-if="read_only==true || working_question.answers_read_only[participant_id]==true"><p>{{ working_question.answers_summary[participant_id] }}</p></span>
		<span v-else class="select_wrapper">
			<select class="styled_select" :name="'question_'+question.id+'_'+participant_id" :id="'question_'+question.id+'_'+participant_id" v-model="working_question.answers_summary[participant_id]">
				<option value="">Please select an option</option>
				<option v-for="option in splitOptions(question.values.options)">{{ option }}</option>
			</select>
		</span>
	</p>
	<p v-else-if="Object.keys(working_question).length > 0 && question.values.field_type=='checkboxes'" :class="{styled_checkboxes: read_only==false}">
		<span class="label">{{ question.values.label }}</span>
		<span v-if="read_only==true || working_question.answers_read_only[participant_id]==true">
			<p v-for="answer in working_question.answers_summary[participant_id]">
				{{ answer }}
			</p>
		</span>
		<span v-else v-for="(option, key) in splitOptions(question.values.options)">
			<input type="checkbox" :name="'question_'+question.id+'_'+participant_id+'[]'" :id="'question_'+question.id+'_'+key+'_'+participant_id" :value="option" v-model="working_question.answers_summary[participant_id]">
			<label :for="'question_'+question.id+'_'+key+'_'+participant_id">{{ option }}</label>
		</span>
	</p>
	<p v-else-if="Object.keys(working_question).length > 0 && question.values.field_type=='radios'" :class="{styled_radios: read_only==false}">
		<span class="label">{{ question.values.label }}</span>
		<span v-if="read_only==true || working_question.answers_read_only[participant_id]==true"><p>{{ working_question.answers_summary[participant_id] }}</p></span>
		<template v-else>
			<span v-for="(option, key) in splitOptions(question.values.options)">
				<input type="radio" :name="'question_'+question.id+'_'+participant_id" :id="'question_'+question.id+'_'+key+'_'+participant_id" :value="option" v-model="working_question.answers_summary[participant_id]">
				<label :for="'question_'+question.id+'_'+key+'_'+participant_id">{{ option }}</label>
			</span>
		</template>
	</p>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {

	props: [
		'question',
		'participant_id',
		'read_only'
	],

	data: () => {
		return {
			working_question: {}
		}
	},

	computed: {

	},

	watch: {

	},

	created() {
		this.working_question = this.question;
		if (this.question.values.field_type == 'checkboxes') {
			if (this.question.answers_summary[this.participant_id] == null) {
				this.working_question.answers_summary[this.participant_id] = [];
			}
		}
	},

	mounted() {

	},

	methods: {

		splitOptions: function (string) {
			string = string.replace(/(?:\r\n|\r|\n)/g, '|'); // replace line breaks with pipe character
			var array = string.split("|"); // split on the pipe
			array = array.filter(function (el) { return el; }); // filter blank elements
			return array;
		}

	}
};
</script>